import { gql } from 'graphql-request';

export const SEED_DENSITY_RECOMMENDATION = gql`
  query ($input: SeedDensityRecommendationInput!) {
    seedingRateRecommendation(input: $input) {
      curve {
        plantingRate
        plantingRateUnit
        yield
        yieldUnit
      }
      targetYield {
        u
        v
      }
    }
  }
`;
